import { SET_ORGANIZATION_TYPES } from '../constants/dictionaries';

export const setOrganizationTypes = (data) => ({
  type: SET_ORGANIZATION_TYPES,
  payload: data,
});
